import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import RealTimeNotification from "../../components/Notifications/RealTimeNotification";
import { selectUserInformations } from "../../features/authSlice";
import { getNotifications, getUnClickedNotification, updateUnClickedNumberNotification } from "../../features/notifications/notificationSlice";

const GlobalNotification = ({ children }) => {
    const { notifications } = useSelector(getNotifications);
    const [newNotification, setNewNotification] = useState(false);
    const [slideIn, setSlideIn] = useState(false);
    const [notification, setNotification] = useState(null);
    const user = useSelector(selectUserInformations);
    const unClickedNotifications = useSelector(getUnClickedNotification)
    const dispatch = useDispatch();

    useEffect(() => {
        if (notifications) {
            setNotification(notifications);
            setNewNotification(true);
            setSlideIn(true);
            dispatch(updateUnClickedNumberNotification(unClickedNotifications + 1))

            // Auto-hide notification
            const timeout = setTimeout(() => {
                setSlideIn(false);
                setNewNotification(false);
            }, 10000); // 20 seconds

            return () => clearTimeout(timeout);
        }
    }, [notifications, dispatch]);

    useEffect(() => {
        // console.log(slideIn)
    }, [slideIn])

    return (
        <>
            {newNotification && (
                <RealTimeNotification
                    notification={notification}
                    isVisible={true}
                    slideIn={slideIn}
                    user={user}
                />
            )}

            {children}
        </>
    );
};

export default GlobalNotification;
